module.exports = (__parcel__import__("gwshs")).then(() => parcelRequire('ieIpp'));